module.exports = __webpack_public_path__ + "media/images/emblems/Le_Landeron_Wappen-6fdf72a6f9b9602997ee7143d9f6d01d.png";